import styled from "styled-components";
import { COLORS, DARK_THEME_COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import * as mediaQuery from "components/MediaQuery";
import { calcRem } from "styles/theme";
import Type from "components/atoms/text/labels/Type";
import { convertType } from "utils/functions";
import { FLEX } from "styles/flex";

type RecorderTitleProps = {
  mergedSystemName: string;
  recorderName: string;
  type?: string;
  recorderCount?: number;
  isShowType?: boolean;
  displayType?: string;
  licenseType?: string | null;
  isCloudCam?: boolean;
};

function RecorderTitle(props: RecorderTitleProps): JSX.Element {
  return (
    <AlertTitleName data-tag="allowRowEvents">
      {props.isShowType !== undefined && props.type && (
        <Type
          type={convertType({
            type: props.type,
            displayType: props.displayType,
          })}
          licenseType={props.licenseType}
          isCloudCam={props.isCloudCam}
        />
      )}
      <div className="recorder-title-wrapper">
        {props.type !== undefined ? (
          props.type !== "Spectrum" ? (
            <span data-tag="allowRowEvents">{props.mergedSystemName}</span>
          ) : (
            <>
              <span data-tag="allowRowEvents">{props.mergedSystemName}</span>
              <span className="server-name" data-tag="allowRowEvents">
                {" "}
                {props.recorderName}
              </span>
            </>
          )
        ) : props.mergedSystemName === props.recorderName ? (
          <span data-tag="allowRowEvents">{props.mergedSystemName}</span>
        ) : (
          <>
            <span data-tag="allowRowEvents">{props.mergedSystemName}</span>
            <span className="server-name" data-tag="allowRowEvents">
              {" "}
              {props.recorderName}
            </span>
          </>
        )}
        {(props.recorderCount || 0) > 1 && (
          <span className="merged" data-tag="allowRowEvents">
            [{props.recorderCount} Servers Merged]
          </span>
        )}
      </div>
    </AlertTitleName>
  );
}

export default RecorderTitle;

const AlertTitleName = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(14)};
  line-height: 120%;
  .recorder-title-wrapper {
    min-width: 100px;
  }
  .merged {
    display: block;
    padding-top: 1px;
    color: ${({ theme }) =>
      theme.value === "light"
        ? LIGHT_THEME_COLORS.STATUS
        : DARK_THEME_COLORS.STATUS};
  }
  span {
    flex-wrap: wrap;
    column-gap: 4px;
    line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-word;
    white-space: normal;
    ${mediaQuery.isTablet} {
      flex-direction: column;
      margin: 0;
      gap: 0;
      ${FLEX.FlexStartStart};
    }
  }
  .server-name {
    color: ${COLORS.BUTTONS1};
    font-size: ${calcRem(13)};
  }
`;
